import { inject } from '@angular/core';
import { ResolveFn, ActivatedRouteSnapshot, Router } from '@angular/router';
import { catchError, of } from 'rxjs';

import { PaylinkService, PaylinkApiError } from '../services/paylink.service';
import { LinkData } from '../models/paylink.model';

import { getOrCreateReservationToken } from '../utils/reservation-token.util';

export const paymentLinkResolver: ResolveFn<LinkData | null> = (
  route: ActivatedRouteSnapshot
) => {

  const paylinkService = inject(PaylinkService);
  const router = inject(Router);
  // const linkId = route.paramMap.get('linkId');
  const linkId =
    route.paramMap.get('linkId') ||
    route.queryParamMap.get('identifier');

  if (!linkId) {
    return of(null);
  }

  const reservationToken = getOrCreateReservationToken(linkId);

  return paylinkService.getLinkData(linkId, reservationToken).pipe(
    catchError((error) => {
      if (error instanceof PaylinkApiError) {
        router.navigate(['/error'], {
          queryParams: { code: error.code, message: error.message, linkId }
        });
      }
      return of(null);
    })
  );
};
